import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { FORCE_PRODUCT_SYNC, GET_OFFERS_BY_ACCEPTED_MODELS, GET_SHARED_OFFER, MOVEMENTS, OFFERS, PAYMENTRULES, PRODUCT, PUBLISH, RETURNRULES, SHARE_OFFER, SITES } from '../endpointList';
import { fetchRequest, getOptions, urlRequestParamBuilder } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';
import ChangeSites from '../../components/user/ChangeSites';

const token = getCookie(cookieName.token);

const useOffer = () => {
    const [getOfferByIDResponse, setGetOfferByIDResponse] = useState<any>();
    const [getOfferByIDResult, setGetOfferByIDResult] = useState<any>();
    const [updateResponse, setUpdateResponse] = useState<any>();
    const [updateResult, setUpdateResult] = useState<any>();
    const [createResponse, setCreateResponse] = useState<any>();
    const [createResult, setCreateResult] = useState<any>();
    const [deleteResponse, setDeleteResponse] = useState<any>();
    const [deleteResult, setDeleteResult] = useState<any>();
    const [getOffersListAllResponse, setGetOffersListAllResponse] = useState<any>();
    const [getOffersListAllResult, setGetOffersListAllResult] = useState<any>();
    const [getOffersListPaginatedResponse, setGetOffersListPaginatedResponse] = useState<any>();
    const [getOffersListPaginatedResult, setGetOffersListPaginatedResult] = useState<any>();
    const [getOffersByAcceptedModelIdResponse, setGetOffersByAcceptedModelIdResponse] = useState<any>();
    const [getOffersByAcceptedModelIdResult, setGetOffersByAcceptedModelIdResult] = useState<any>();
    const [shareOfferResponse, setShareOfferResponse] = useState<any>();
    const [shareOfferResult, setShareOfferResult] = useState<any>();
    const [getSharedOfferResponse, setGetSharedOfferResponse] = useState<any>();
    const [getSharedOfferResult, setGetSharedOffererResult] = useState<any>();

    // BEB
    const [createProductResponse, setCreateProductResponse] = useState<any>();
    const [createProductResult, setCreateProductResult] = useState<any>();

    const [cloneProductResponse, setCloneProductResponse] = useState<any>();
    const [cloneProductResult, setCloneProductResult] = useState<any>();

    const [filterProductsResponse, setFilterProductsResponse] = useState<any>();
    const [filterProductsResult, setFilterProductsResult] = useState<any>();

    const [paymentRulesResponse, setPaymentRulesResponse] = useState<any>();
    const [paymentRulesResult, setPaymentRulesResult] = useState<any>();

    const [returnRulesResponse, setReturnRulesResponse] = useState<any>();
    const [returnRulesResult, setReturnRulesResult] = useState<any>();

    const [getProductDetailsResponse, setGetProductDetailsResponse] = useState<any>();
    const [getProductDetailsResult, setGetProductDetailsResult] = useState<any>();

    const [deleteProductResponse, setDeleteProductResponse] = useState<any>();
    const [deleteProductResult, setDeleteProductResult] = useState<any>();

    const [publishedProductResponse, setPublishedProductResponse] = useState<any>();
    const [publishedProductResult, setPublishedProductResult] = useState<any>();

    const [getSitesResponse, setGetSitesResponse] = useState<any>();
    const [getSitesResult, setGetSitesResult] = useState<any>();
    
    const [changeSitesResponse, setChangeSitesResponse] = useState<any>();
    const [changeSitesResult, setChangeSitesResult] = useState<any>();

    const [createSupplierResponse, setCreateSupplierResponse] = useState<any>();
    const [createSupplierResult, setCreateSupplierResult] = useState<any>();

    const [updateSupplierResponse, setUpdateSupplierResponse] = useState<any>();
    const [updateSupplierResult, setUpdateSupplierResult] = useState<any>();

    const [getSupplierResponse, setGetSupplierResponse] = useState<any>();
    const [getSupplierResult, setGetSupplierResult] = useState<any>();

    const [getSuppliersResponse, setGetSuppliersResponse] = useState<any>();
    const [getSuppliersResult, setGetSuppliersResult] = useState<any>();

    const [deleteSuppliersResponse, setDeleteSuppliersResponse] = useState<any>();
    const [deleteSuppliersResult, setDeleteSuppliersResult] = useState<any>();

    const [addSupplierToProductResponse, setAddSupplierToProductResponse] = useState<any>();
    const [addSupplierToProductResult, setAddSupplierToProductResult] = useState<any>();
    
    // const [editSitesResponse, setEditSitesResponse] = useState<any>();
    // const [editSitesResult, setEditSitesResult] = useState<any>();

    const [editPublishProductResponse, setEditPublishProductResponse] = useState<any>();
    const [editPublishProductResult, setEditPublishProductResult] = useState<any>();

    const [getMovementsResponse, setGetMovementsResponse] = useState<any>();
    const [getMovementsResult, setGetMovementsResult] = useState<any>();

    const [updateMovementsResponse, setUpdateMovementsResponse] = useState<any>();
    const [updateMovementsResult, setUpdateMovementsResult] = useState<any>();

    const [createSiteResponse, setCreateSiteResponse] = useState<any>();
    const [createSiteResult, setCreateSiteResult] = useState<any>();

    const [removeSiteResponse, setRemoveSiteResponse] = useState<any>();
    const [removeSiteResult, setRemoveSiteResult] = useState<any>();

    const [forceProductSyncResult, setForceProductSyncResult] = useState<any>();
    const [forceProductSyncResponse, setForeceProductSyncResponse] = useState<any>();

    const createSupplier = (obj: any) => {
        const url = `${apiURL}/suppliers`;
        const options = getOptions({
            method: 'POST',
            body: { ...obj },
            token: token,
        });
        fetchRequest(url, options, setCreateSupplierResponse, setCreateSupplierResult);
    };

    const updateSupplier = (obj: any, id:number) => {
        const url = `${apiURL}/suppliers/${id}`;
        const options = getOptions({
            method: 'PUT',
            body: { ...obj },
            token: token,
        });
        fetchRequest(url, options, setUpdateSupplierResponse, setUpdateSupplierResult);
    };

    const getSupplier = ( id:number) => {
        const url = `${apiURL}/suppliers/${id}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setGetSupplierResponse, setGetSupplierResult);
    };

    const getSuppliers = () => {
        const url = `${apiURL}/suppliers`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setGetSuppliersResponse, setGetSuppliersResult);
    };

    const deleteSupplier = (id:number) => {
        const url = `${apiURL}/suppliers/${id}`;
        const options = getOptions({
            method: 'DELETE',
            token: token,
        });
        fetchRequest(url, options, setDeleteSuppliersResponse, setDeleteSuppliersResult);
    };

    const addSupplierToProduct = (product_sku:string,supplier_id:number) => {
        const url = `${apiURL}/products/${product_sku}/suppliers`;
        const options = getOptions({
            method: 'POST',
            body: {
                supplierId:supplier_id,
            },
            token: token,
        });
        fetchRequest(url, options, setAddSupplierToProductResponse, setAddSupplierToProductResult);
    };


    const createOffer = (obj: any) => {
        const url = `${apiURL}/${OFFERS}`;
        const options = getOptions({
            method: 'POST',
            body: { ...obj },
            token: token,
        });
        fetchRequest(url, options, setCreateResponse, setCreateResult);
    };

    const updateOffer = (id: number, obj: any) => {
        const url = `${apiURL}/${OFFERS}/${id}`;
        const options = getOptions({
            method: 'PUT',
            body: { ...obj },
            token: token,
        });
        fetchRequest(url, options, setUpdateResponse, setUpdateResult);
    };

    const deleteOffer = (id: number) => {
        const url = `${apiURL}/${OFFERS}/${id}`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeleteResponse, setDeleteResult);
    };

    const getOfferById = (id: number) => {
        const url = `${apiURL}/${OFFERS}/${id}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetOfferByIDResponse, setGetOfferByIDResult);
    };

    const getOffersByAcceptedModelId = (model_id: number) => {
        const url = `${apiURL}/${GET_OFFERS_BY_ACCEPTED_MODELS}/${model_id}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetOffersByAcceptedModelIdResponse, setGetOffersByAcceptedModelIdResult);
    };

    const getOffersListAll = () => {
        const url = `${apiURL}/${OFFERS}/all`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetOffersListAllResponse, setGetOffersListAllResult);
    };

    const getOffersListPaginated = () => {
        const url = `${apiURL}/${OFFERS}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetOffersListPaginatedResponse, setGetOffersListPaginatedResult);
    };

    const shareOffer = (offer_id: number, obj: any) => {
        let params = null;
        if (obj != null) {
            params = urlRequestParamBuilder(obj);
        }
        const url = `${apiURL}/${SHARE_OFFER}/${offer_id}${params ? params : ''}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setShareOfferResponse, setShareOfferResult);
    };

    const getSharedOffer = (obj: any) => {
        const params = urlRequestParamBuilder(obj);
        const url = `${apiURL}/${GET_SHARED_OFFER}${params ? params : ''}`;
        const options = getOptions({
            method: 'POST',
            token: obj.tempToken,
        });
        fetchRequest(url, options, setGetSharedOfferResponse, setGetSharedOffererResult);
    };

    // BEB
    const createProduct = (obj: any) => {
        const title = encodeURI(obj.title);
        const description = encodeURI(obj.long_description);
        const url = `${apiURL}/${PRODUCT}?title=${title}&long_description=${description || ''}&quantity=${obj.quantity !== '' ? obj.quantity : '1'}&final_price=${obj.final_price}&waist=${
            obj.waist
        }&category_id=${obj.category_id}&user_id=${obj.user_id}&payment_rule_id=${obj.payment_rule_id}&condition_id=${obj.condition_id}&return_rule_id=${obj.return_rule_id}`;
        const options = getOptions({
            method: 'POST',
            token: token,
            body: {
                images: obj.images,
            },
        });
        fetchRequest(url, options, setCreateProductResponse, setCreateProductResult);
    };

    const changeSites = (obj:any) =>{
        const from_id = obj.from_id === -1 ? '' : `?from_id=${obj.from_id}`;
        const to_id = obj.to_id === -1 ? '' : `&to_id=${obj.to_id}`;

        var categoories_array= Array<any>([]);
     
        if(obj.category_id!==-1){
            let category={
                id: Number
            };
            category=obj.category_id;
            categoories_array.push(category);
        }

        var options;
        const url = `${apiURL}/operations/change_products_sites${from_id}${to_id}`;

        if(obj.category_id!==-1){
            options = getOptions({
                method: 'POST',
                token: token,
                body: {
                    sites: obj.sites,
                    categories: obj.categories,
                },
            });
        }else{
            options = getOptions({
                method: 'POST',
                token: token,
                body: {
                    sites: obj.sites,
                },
            });
        }
        
        fetchRequest(url, options, setChangeSitesResponse, setChangeSitesResult);

    }

    const getProductDetails = (sku: string) => {
        const url = `${apiURL}/products/${sku}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setGetProductDetailsResponse, setGetProductDetailsResult);
    };

    const changePublishProduct = (sku: string, publishedId: number, obj: any) => {
        
        const title = encodeURI(obj.title);
        const conto_vendita=obj.conto_vendita!==null && obj.conto_vendita!==undefined ? "&conto_vendita="+obj.conto_vendita : '';
        const description = obj.long_description && obj.long_description!==null && obj.long_description!==undefined && obj.long_description!=='null' && obj.long_description!=='undefined' && (obj.long_description!=='') && !String(obj.long_description).includes("undefined") ? obj.long_description : '';
        const condition=obj.condition_id && obj.condition_id !== 'undefined' && obj.condition_id !== 'null' ? "&condition_id="+Number(obj.condition_id) : '';
        const category=obj.category_id && obj.category_id !== 'undefined' && obj.category_id !== 'null' ? "&category_id="+Number(obj.category_id) : '';
        const ean = obj.ean && obj.ean !== 'null' && obj.ean !=='undefined' && obj.ean !== '' ? "&ean="+obj.ean : '';
        const brand = obj.brand && obj.brand !=='null' && obj.brand !== 'undefined' && obj.brand !=='' ?  "&brand="+obj.brand : '';
        const paymentRule = obj.payment_rule_id && obj.payment_rule_id !==null && obj.payment_rule_id!==undefined && obj.payment_rule_id!=='' ? "&payment_rule_id="+obj.payment_rule_id : '';
        const returnRule = obj.return_rule_id && obj.return_rule_id !==null && obj.return_rule_id!==undefined && obj.return_rule_id!=='' ? "&return_rule_id="+obj.return_rule_id : '';
        const notes = obj.notes&& obj.notes !==null && obj.notes!==undefined && obj.notes!=='' ? "&notes="+obj.notes : '';

        const url = `${apiURL}/${PRODUCT}/${sku}?title=${title}&final_price=${obj.final_price}&waist=${obj.waist}${category}&user_id=${obj.user_id}${paymentRule}${condition}${returnRule}&published=${publishedId}${notes}${brand}${ean}${conto_vendita}`;

        const bodyBase: any = { sites: obj.sites, images: obj.images };
        if (description !== '') bodyBase.long_description = description;
        if (obj.vendor_id != null && obj.vendor_id !== '' && obj.vendor_id !== 'null') bodyBase.vendor_id = Number(obj.vendor_id);

        if(token===null || token==='' || token===undefined){
            const options = getOptions({
                method: 'PUT',
                token: localStorage.getItem("userToken"),
                body: bodyBase,
            });
            fetchRequest(url, options, setPublishedProductResponse, setPublishedProductResult);
        }else{
            const options = getOptions({
                method: 'PUT',
                token: token,
                body: bodyBase,
            });
            fetchRequest(url, options, setPublishedProductResponse, setPublishedProductResult);
        }

        
        // console.log(url, options);
    };

    const forceSync = (sku:string) =>{
        const url=`${apiURL}/${FORCE_PRODUCT_SYNC}/${sku}`;
        const options = getOptions({
            method: 'POST',
            token: token,
        });
        fetchRequest(url, options, setForeceProductSyncResponse, setForceProductSyncResult);
    };

    const editPublishProduct = (sku: string) => {
        const url = `${apiURL}/${PUBLISH}/${sku}`;
        const options = getOptions({
            method: 'PUT',
            token: token,
        });
        fetchRequest(url, options, setEditPublishProductResponse, setEditPublishProductResult);
    };

    const deleteProduct = (sku: string) => {
        const url = `${apiURL}/${PRODUCT}/${sku}/delete`;
        const options = getOptions({
            method: 'DELETE',
            token: token,
        });

        fetchRequest(url, options, setDeleteProductResponse, setDeleteProductResult);
    };

    const cloneProduct = async (sku: string) => {
        const url = `${apiURL}/${PRODUCT}/${sku}/clone`;
        const options = getOptions({
            method: 'POST',
            token: token,
        });
        await fetchRequest(url, options, setCloneProductResponse, setCloneProductResult);
    };

    const filterProducts = async (obj?: any) => {
        const keyword = obj && obj.keyword && obj.keyword !== '' ? `?keyword=${encodeURI(obj.keyword)}` : '';
        const published = obj && obj.published && obj.published !== 'null' ? `&published=${obj.published}` : '';
        const condition = obj && obj.conditionId && obj.conditionId !== 'null' ? `&condition_id=${obj.conditionId}` : '';
        const category = obj && obj.categoryId && obj.categoryId !== 'null' ? `&category_id=${obj.categoryId}` : '';
        const page = obj ? '&page=1' : '';

        const url = `${apiURL}/search/${PRODUCT}${keyword + published + condition + category + page}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        console.log(url);
        fetchRequest(url, options, setFilterProductsResponse, setFilterProductsResult);
    };

    const getPaymentRules = () => {
        const url = `${apiURL}/${PAYMENTRULES}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setPaymentRulesResponse, setPaymentRulesResult);
    };

    const getReturnRules = () => {
        const url = `${apiURL}/${RETURNRULES}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setReturnRulesResponse, setReturnRulesResult);
    };

    const getSites = () => {
        const url = `${apiURL}/${SITES}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });
        fetchRequest(url, options, setGetSitesResponse, setGetSitesResult);
    };

    const createSite = (name: string) => {
        const url = `${apiURL}/${SITES}?site=${name}`;
        const options = getOptions({
            method: 'POST',
            token: token,
        });
        fetchRequest(url, options, setCreateSiteResponse, setCreateSiteResult);
    };

    // const removeSite = (id: any) => {
    //     const url = `${apiURL}/${SITES}?site=${name}`;
    //     const options = getOptions({
    //         method: 'POST',
    //         token: token,
    //     });
    //     fetchRequest(url, options, setCreateSiteResponse, setCreateSiteResult);
    // };

    // const updateSite = (sku: string, siteId: number) => {
    //     const url = `${apiURL}/${PRODUCT}/${sku}/${siteId}`;
    //     const options = getOptions({
    //         method: 'PUT',
    //         token: token,
    //         // body: {
    //         //     sites: [{ id: siteId }],
    //         // },
    //     });

    //     fetchRequest(url, options, setEditSitesResponse, setEditSitesResult);
    // };

    const getMovements = (sku: string) => {
        const url = `${apiURL}/${PRODUCT}/${sku}/${MOVEMENTS}`;
        const options = getOptions({
            method: 'GET',
            token: token,
        });

        fetchRequest(url, options, setGetMovementsResponse, setGetMovementsResult);
    };

    const updateMovements = (sku: string, quantity: string, notes :string|null) => {

        let note='&notes='+notes;
        if(notes===null || notes===''){
            note='';
        }
        const url = `${apiURL}/${PRODUCT}/${sku}/${MOVEMENTS}?quantity=${quantity}${note}`;
        const options = getOptions({
            method: 'PUT',
            token: token,
        });

        fetchRequest(url, options, setUpdateMovementsResponse, setUpdateMovementsResult);
    };

    const RESPONSES = {
        getOfferByIDResponse,
        updateResponse,
        createResponse,
        deleteResponse,
        getOffersListAllResponse,
        getOffersListPaginatedResponse,
        getOffersByAcceptedModelIdResponse,
        shareOfferResponse,
        getSharedOfferResponse,
        filterProductsResponse,
        paymentRulesResponse,
        returnRulesResponse,
        createProductResponse,
        getProductDetailsResponse,
        deleteProductResponse,
        publishedProductResponse,
        cloneProductResponse,
        getSitesResponse,
        // editSitesResponse,
        editPublishProductResponse,
        getMovementsResponse,
        updateMovementsResponse,
        forceProductSyncResponse,
        createSiteResponse,
        removeSiteResponse,
        changeSitesResponse,
        createSupplierResponse,
        updateSupplierResponse,
        getSupplierResponse,
        getSuppliersResponse,
        deleteSuppliersResponse,
        addSupplierToProductResponse,
    };

    const RESULTS = {
        changeSitesResult,
        getOfferByIDResult,
        updateResult,
        createResult,
        deleteResult,
        forceProductSyncResult,
        getOffersListAllResult,
        getOffersListPaginatedResult,
        getOffersByAcceptedModelIdResult,
        shareOfferResult,
        getSharedOfferResult,
        filterProductsResult,
        paymentRulesResult,
        returnRulesResult,
        createProductResult,
        getProductDetailsResult,
        deleteProductResult,
        publishedProductResult,
        cloneProductResult,
        getSitesResult,
        // editSitesResult,
        editPublishProductResult,
        getMovementsResult,
        updateMovementsResult,
        createSiteResult,
        removeSiteResult,
        createSupplierResult,
        updateSupplierResult,
        getSupplierResult,
        getSuppliersResult,
        deleteSuppliersResult,
        addSupplierToProductResult,
    };

    const CTAs = {
        changeSites,
        createOffer,
        updateOffer,
        deleteOffer,
        getOfferById,
        getOffersListAll,
        getOffersListPaginated,
        getOffersByAcceptedModelId,
        shareOffer,
        getSharedOffer,
        filterProducts,
        getPaymentRules,
        getReturnRules,
        createProduct,
        getProductDetails,
        deleteProduct,
        changePublishProduct,
        cloneProduct,
        getSites,
        // updateSite,
        editPublishProduct,
        getMovements,
        updateMovements,
        createSite,
        forceSync,
        createSupplier,
        updateSupplier,
        getSupplier,
        getSuppliers,
        deleteSupplier,
        addSupplierToProduct,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useOffer;
